import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  PLATFORM_CATEGORY,
  PLATFORM_ID,
  PLATFORM_VERSION,
} from "../../../Common/constants";
import { getPath, getTranslations } from "../../../Common/utils";
import { league } from "../../../redux/actions";
import { CtaButton, Overlays } from "../../../ReusableComponents";
import useTournamentScanario from "../../../Common/hooks/useTournamentScanario";
import LeagueBody from "../LeagueBody";

const LeaveLeague = ({
  leagueId,
  userTeams,
  pushLeaveLeagueDataLayer,
  pushLeaveLeaguePopupDataLayer,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isEos, lastGamedayRaceLocked } = useTournamentScanario();
  const [showLeavePopup, setShowLeavePopup] = useState();
  const disableCTAs = isEos || lastGamedayRaceLocked;
  const togglePopup = () => {
    setShowLeavePopup((prev) => !prev);
  };

  const leagueState = useSelector((state) => state.league);
  const translationState = useSelector((state) => state.translation);
  const { leaveLeagueSuccess } = leagueState;

  const handleConfirm = () => {
    const payload = {
      optType: 0,
      platformId: PLATFORM_ID,
      platformVersion: PLATFORM_VERSION,
      platformCategory: PLATFORM_CATEGORY,
      leagueId: leagueId,
      teamNumber: userTeams,
    };
    dispatch(league.leaveLeague(payload));
    togglePopup();
  };

  useEffect(() => {
    if (leaveLeagueSuccess) {
      navigate(getPath(translationState, "leagues"));
      pushLeaveLeaguePopupDataLayer("CONFIRM");
    }
  }, [leaveLeagueSuccess]);

  return (
    <>
      <CtaButton
        variant={"secondary"}
        leadingIcon
        icon="f1i-leave"
        disabled={disableCTAs}
        onClick={() => {
          togglePopup();
          if (!showLeavePopup) {
            pushLeaveLeagueDataLayer();
          }
        }}
      >
        {getTranslations("manage_league_leave_league_button", "Leave League")}
      </CtaButton>
      {showLeavePopup && (
        <Overlays
        overlayName="leaveLeague"
          overlayTitle={getTranslations(
            "manage_league_leave_league_popup_title",
            "Leaving so soon?"
          )}
          overlaySubTitle={getTranslations(
            "manage_league_leave_league_popup_message",
            "Are you sure you want to leave the league? You’ll be missed!"
          )}
          btnPrimary={getTranslations(
            "manage_league_leave_league_popup_confirm_button",
            "Leave league"
          )}
          btnSecondary={getTranslations(
            "manage_league_leave_league_popup_cancel_button",
            "Go back"
          )}
          overlayConfig={{ cancelBtn: true, showOverlaySub_Title: true }}
          component={<LeagueBody />}
          onCancelClick={() => {
            togglePopup();
            pushLeaveLeaguePopupDataLayer("CANCEL");
          }}
          onConfirmClick={() => {
            handleConfirm();
          }}
        />
      )}
    </>
  );
};

export { LeaveLeague };
